<div class="app-component">
  <router-outlet> </router-outlet>
  <hb-coachmark-component></hb-coachmark-component>
</div>
